import React from 'react';
import { splitShopProductTitle } from '../../utils/shop';

export default function ShopProductTitle({ title, promoClassName = 'list-title-promo' }) {
  const { main, promo } = splitShopProductTitle(title);

  if (!promo) {
    return <>{main}</>;
  }

  return (
    <>
      <span className="shop-product-title__main">{main}</span>
      <span className={promoClassName}>{promo}</span>
    </>
  );
}
